/* eslint-disable no-shadow */
/* eslint-disable no-case-declarations */
/* eslint-disable react/jsx-handler-names */
import React from 'react';

import { get } from 'lodash';

import TextInput from '../components/Form/TextInput';
import Select from '../components/Form/Select';
import Datepicker from '../components/Form/Datepicker';
import Radio from '../components/Form/Radio';
import Textarea from '../components/Form/Textarea';
import SelectWithFetchableOptions from '../components/Form/SelectWithFetchableOptions';
import CurrencyInput from '../components/Form/CurrencyInput';
import PercentageInput from '../components/Form/PercentageInput';
import Checkbox from '../components/Form/Checkbox';
import PaymentWaterfall from '../components/Form/PaymentWaterfall';
import ImageUploader from '../components/Form/ImageUploader';
import BankAccountInput from '../components/Form/BankAccountInput';
import NumberPercentageArray from '../components/Form/NumberPercentageArray';
import EditableText from '../components/Form/EditableText';
import DocumentUploader from '../components/Form/DocumentUploader';

export default function renderFormInputs({
  fields,
  formik,
  prevGroupsSize,
  isVisible,
  tabindex,
  isSettingsForm,
  readOnly,
  isArray,
  innerIndex,
  arrayFieldName,
}) {
  return fields.map((field, index) => {
    if (field.isHidden && field.isHidden(formik.values)) {
      return null;
    }

    let options = field?.options;
    if (field.type === 'select' && typeof field.options === 'function') {
      options = field.options(formik.values);
    }

    let value = isArray
      ? get(formik.values, `${arrayFieldName}[${innerIndex}].${field.name}`)
      : get(formik.values, field.name);

    if (field.format && !isArray) {
      value = field.format(formik.values);
    }

    const name = isArray
      ? `${arrayFieldName}[${innerIndex}].${field.name}`
      : field.name;

    // console.log(name, formik.errors, get(formik.errors, name));

    const label =
      typeof field.title === 'function'
        ? field.title(formik.values, index, innerIndex)
        : field.title;

    switch (field.type) {
      case 'text':
      case 'password':
        return (
          <TextInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            mask={field.mask}
            readOnly={field.readOnly || readOnly}
            disabled={readOnly}
            postfix={field.postfix}
            maxLength={field.maxLength}
            type={field.type}
            tooltip={field.tooltip ? field.tooltip(formik.values) : null}
          />
        );
      case 'bankAccountNumber':
        return (
          <BankAccountInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={get(formik.values, field.name)}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            mask={field.mask}
            readOnly={field.readOnly}
            disabled={readOnly}
            postfix={field.postfix}
          />
        );
      case 'number':
        return (
          <TextInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            type="number"
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={get(formik.values, field.name)}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            disabled={readOnly}
          />
        );
      case 'currency':
        return (
          <CurrencyInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            disabled={readOnly}
            tooltipSize={field.tooltipSize}
            tooltipPosition={field.tooltipPosition}
            tooltip={
              typeof field.tooltip === 'function'
                ? field.tooltip(formik.values)
                : field.tooltip
            }
          />
        );
      case 'percentage':
        return (
          <PercentageInput
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={get(formik.values, field.name)}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            limitDecimals={field.limitDecimals}
          />
        );
      case 'textarea':
        return (
          <Textarea
            tabindex={tabindex || index + 1 + prevGroupsSize}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            tooltip={field.tooltip ? field.tooltip(formik.values) : null}
            className={field.className}
            rows={field.rows}
            maxLength={field.maxLength}
          />
        );
      case 'select':
        return (
          <Select
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={name}
            name={name}
            label={label}
            options={
              typeof options === 'function' ? options(formik.values) : options
            }
            value={get(formik.values, name)}
            setFieldValue={formik.setFieldValue}
            onBlur={formik.handleBlur}
            error={get(formik.errors, name)}
            touched={get(formik.touched, name)}
            url={field.url}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            defaultValue={field.defaultValue}
            link={field.link}
          />
        );
      case 'fetchableSelect':
        return (
          <SelectWithFetchableOptions
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={name}
            name={name}
            label={label}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            setFieldValue={(name, val) => {
              formik.setFieldValue(name, val);

              if (field.afterChange) {
                field.afterChange(val, formik.setFieldValue);
              }
            }}
            error={get(formik.errors, name)}
            touched={get(formik.touched, name)}
            fetchOptions={field.fetchOptions}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            hideIfNoOptions={field.hideIfNoOptions}
            style={field.style}
            className={field.className}
            nullable={field.nullable}
            link={field.link}
            tooltipSize={field.tooltipSize}
            tooltipPosition={field.tooltipPosition}
            tooltip={
              typeof field.tooltip === 'function'
                ? field.tooltip(formik.values)
                : field.tooltip
            }
          />
        );
      case 'date':
        return (
          <Datepicker
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={name}
            name={name}
            label={label}
            placeholder={field.placeholder}
            value={value}
            setFieldValue={formik.setFieldValue}
            onBlur={formik.handleBlur}
            error={get(formik.errors, name)}
            touched={get(formik.touched, name)}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            disablePastDates={field.disablePastDates}
            link={field.link}
            onReadOnlyClick={field.onReadOnlyClick}
            tooltip={field.tooltip}
          />
        );
      case 'paymentWaterfall':
        return (
          <PaymentWaterfall
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            placeholder={field.placeholder}
            value={get(formik.values, field.name)}
            setFieldValue={formik.setFieldValue}
            isVisible={isVisible}
            label={label}
            lenderId={formik.values?.lender_id}
            readOnly={field.readOnly || readOnly}
          />
        );
      case 'radio':
        return (
          <Radio
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            value={get(formik.values, field.name)}
            onChange={(event) => {
              if (event.target.value === 'true') {
                formik.setFieldValue(field.name, true);
              } else if (event.target.value === 'false') {
                formik.setFieldValue(field.name, false);
              } else {
                formik.setFieldValue(field.name, event.target.value);
              }
            }}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            options={field.options}
            isVisible={isVisible}
            isSettingsForm={isSettingsForm}
            description={field.description}
            readOnly={field.readOnly || readOnly}
          />
        );
      case 'checkbox':
        return (
          <Checkbox
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            value={get(formik.values, field.name)}
            onChange={(event) =>
              formik.setFieldValue(field.name, event.target.checked)
            }
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            options={field.options}
            isVisible={isVisible}
            disabled={field.readOnly || readOnly}
          />
        );
      case 'image':
        return (
          <ImageUploader
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            value={get(formik.values, field.name)}
            setFieldValue={formik.setFieldValue}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            isVisible={isVisible}
            setTouched={() => {
              setTimeout(() => formik.setFieldTouched(field.name, true));
            }}
            readOnly={field.readOnly || readOnly}
            className={field.className}
            multiple={field.multiple}
          />
        );
      case 'numberPercentageArray':
        return (
          <NumberPercentageArray
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            placeholder={field.placeholder}
            value={get(formik.values, field.name)}
            setFieldValue={formik.setFieldValue}
            isVisible={isVisible}
            label={label}
            lenderId={formik.values?.lender_id}
            readOnly={field.readOnly || readOnly}
            values={formik.values}
            errors={formik.errors}
            touched={formik.touched}
            setFieldTouched={formik.setFieldTouched}
            setTouched={formik.setTouched}
            innerFields={field.innerFields}
            achSchedule={field.achSchedule}
          />
        );
      case 'editableText':
        return (
          <EditableText
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            placeholder={field.placeholder}
            value={value}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            link={field.link}
            isVisible={isVisible}
            mask={field.mask}
            readOnly={field.readOnly || readOnly}
            disabled={readOnly}
          />
        );
      case 'docUploader':
        return (
          <DocumentUploader
            tabindex={tabindex || index + 1 + prevGroupsSize}
            key={field.name}
            name={field.name}
            label={label}
            value={get(formik.values, field.name)}
            setValue={(file) => formik.setFieldValue(name, file)}
            onBlur={formik.handleBlur}
            error={formik.errors[field.name]}
            touched={formik.touched[field.name]}
            isVisible={isVisible}
            readOnly={field.readOnly || readOnly}
            className={field.className}
            multiple={field.multiple}
            placeholder={field.placeholder}
          />
        );
      case 'component':
        const DynamicComponent = field.component;
        const dynamicProps = field.props || {};
        return (
          <DynamicComponent
            key={field.name}
            {...dynamicProps} // Spread the dynamic props
          />
        );
      default:
        return null;
    }
  });
}
